export default __webpack_public_path__ + "media/images/get-ready/profile-2ac0e76bc07f5d63deb74fc2fa87040d.png";